<template>
    <main class="completion-shell">
        <section class="completion-card">
            <q-icon name="o_check_circle" color="positive" class="completion-icon" />
            <h2>Thank you for completing the form</h2>
            <div class="completion-actions">
                <q-btn
                    href="https://www.pw.maori.nz/ko-tatou-recovery-cafe/"
                    class="ko-tatou-btn-outline"
                    unelevated
                    no-caps
                    size="lg"
                    label="Return to Purapura Whetu Website"
                    @click="clearAccess"
                />
                <q-btn
                    :to="{ name: 'publicKoTatou' }"
                    class="ko-tatou-btn"
                    outline
                    no-caps
                    size="lg"
                    label="Complete another form"
                />
            </div>
        </section>
    </main>
</template>

<script>
import publicKoTatou from "@/services/api/publicKoTatou";

export default {
    name: "PublicKoTatouCompleted",
    methods: {
        clearAccess() {
            publicKoTatou.clearAccessToken();
        },
    },
};
</script>

<style scoped src="../assets/styles/public-ko-tatou-completed.css"></style>
